import { z } from "zod";

export const candidateSourceSchema = z.enum(["BACKLOG_LEAD", "SHEET", "MANUAL"]);
export const candidateStatusSchema = z.enum(["PENDING", "APPROVED", "REJECTED", "ON_HOLD"]);
export const candidateOutcomeSchema = z.enum(["WON", "ENDED"]);

export const candidateViewSchema = z.object({
  id: z.string(),
  source: candidateSourceSchema,
  sourceKey: z.string(),
  title: z.string(),
  url: z.string(),
  customerNameHint: z.string(),
  projectNameHint: z.string(),
  outcome: candidateOutcomeSchema,
  wonBasis: z.string(),
  attributes: z.record(z.string(), z.string()),
  assigneeName: z.string().nullable(),
  sourceUpdatedAt: z.string(),
  status: candidateStatusSchema,
  decidedByName: z.string().nullable(),
  decidedAt: z.string().nullable(),
  decisionNote: z.string(),
  resultProjectId: z.string().nullable(),
  resultProjectName: z.string().nullable(),
  lastSeenAt: z.string(),
  revision: z.number(),
  /** ログイン中のユーザーがこの候補を承認・却下できるか。 */
  canDecide: z.boolean(),
});
export type CandidateView = z.infer<typeof candidateViewSchema>;

export const candidateListResponseSchema = z.object({ candidates: z.array(candidateViewSchema) });
export type CandidateListResponse = z.infer<typeof candidateListResponseSchema>;
export const candidateResponseSchema = z.object({ candidate: candidateViewSchema });
export type CandidateResponse = z.infer<typeof candidateResponseSchema>;

export const candidateListQuerySchema = z.object({
  status: candidateStatusSchema.optional(),
  source: candidateSourceSchema.optional(),
});

/** 承認: 新規プロジェクトとして登録するか、既存プロジェクトへ紐付ける。 */
export const approveCandidateRequestSchema = z.discriminatedUnion("mode", [
  z.object({
    mode: z.literal("NEW"),
    revision: z.number().int().positive(),
    name: z.string().trim().min(1, "プロジェクト名は必須です").max(200),
    code: z.string().trim().max(50).optional(),
    customerId: z.string().optional(),
    note: z.string().trim().max(500).optional(),
  }),
  z.object({
    mode: z.literal("EXISTING"),
    revision: z.number().int().positive(),
    projectId: z.string().min(1),
    note: z.string().trim().max(500).optional(),
  }),
]);
export type ApproveCandidateRequest = z.infer<typeof approveCandidateRequestSchema>;

export const decideCandidateRequestSchema = z.object({
  revision: z.number().int().positive(),
  note: z.string().trim().max(500).optional(),
});
export type DecideCandidateRequest = z.infer<typeof decideCandidateRequestSchema>;

export const reopenCandidateRequestSchema = z.object({ revision: z.number().int().positive() });
export type ReopenCandidateRequest = z.infer<typeof reopenCandidateRequestSchema>;
